import React from 'react';

import {PredictionResultsBar} from "./prediction.results-bar";
import {PredictionResultsOptions} from "./prediction.results-options";
import classNames from "classnames";
import styles from "../../style/prediction.module.scss";

export const PredictionResults = ({prediction, controller}) => {
  const {terms: {WEB_PREDICTIONS_WWW_TOTAL_VOTES}} = controller;
  const {enableVoting, showVotes, totalVotes} = prediction;
  const label: String = showVotes ? `${WEB_PREDICTIONS_WWW_TOTAL_VOTES} ${totalVotes?.format()}` : '';

  return (
    !enableVoting ? <div className={classNames(styles.results)}>
      <div className={classNames(styles.total_votes)}>{label}</div>
      <PredictionResultsBar prediction={prediction}/>
      <PredictionResultsOptions prediction={prediction}/>
    </div> : null
  )
};
